import React from 'react';

import Title from './Title';

interface Props {
    address: string;
    title: string;

    children?: React.ReactChild;
}

const HeaderBrowse = (props: Props) => {
    return (
        <div className="row pad-y-2-xs bor-b-0-xs bor-b-0-sm pad-t-3">
            <div className="[ col-xs-24 ]">
                <h1 className="mar-0 line-height-12 mar-b-3">
                    <Title
                        className="display-block font-8 font-feature font-800"
                        text={`${props.title} ${props.address}`}
                    />
                </h1>
            </div>
            {props.children}
        </div>
    );
};

export default HeaderBrowse;
